import { FC } from 'react';
import { startCase } from 'lodash';
import Chip from './';
import { createUseStyles } from 'react-jss';
import { ChipColor, ChipSize } from './helpers';

export type ChipStatus =
  | 'available'
  | 'inactive'
  | 'pending'
  | 'active'
  | 'updating'
  | 'deleting'
  | 'error'
  | 'failed'
  | 'unknown'
  | 'enabled'
  | 'disabled'
  | 'yes'
  | 'no'
  | 'deprecated'
  | 'degraded';

interface Props {
  value: ChipStatus | boolean;
  size?: ChipSize;
  circle?: boolean;
}

const ColorMap: Map<ChipStatus, ChipColor> = new Map();
ColorMap.set('available', 'info');
ColorMap.set('inactive', 'grey');
ColorMap.set('pending', 'warning');
ColorMap.set('active', 'success');
ColorMap.set('updating', 'warning');
ColorMap.set('deleting', 'warning');
ColorMap.set('error', 'error');
ColorMap.set('failed', 'error');
ColorMap.set('unknown', 'warning');
ColorMap.set('enabled', 'success');
ColorMap.set('disabled', 'grey');
ColorMap.set('yes', 'success');
ColorMap.set('no', 'error');
ColorMap.set('deprecated', 'warning');
ColorMap.set('degraded', 'warning');

const useStyles = createUseStyles({
  circle: {
    width: 25,
  },
});

const StatusChip: FC<Props> = ({ value, size = 'medium', circle = false }) => {
  const styles = useStyles();
  const colorMapValue = typeof value === 'boolean' ? (value ? 'enabled' : 'disabled') : value;

  return (
    <Chip
      label={circle ? '' : startCase(colorMapValue)}
      color={ColorMap.get(colorMapValue) || 'primary'}
      size={size}
      className={circle ? styles.circle : ''}
    />
  );
};

export default StatusChip;
